import { DropDown, OdinIcon, OdinIconSize, SplitButton } from '@myosh/odin-components';
import { memo, useCallback, useMemo, useState } from 'react';
import MyoshLogo from '@/assets/myosh.svg';
import AboutModal from '@/components/header/about-modal.component';

const Header = () => {
  const [aboutModalOpen, setAboutModalOpen] = useState(false);

  const openAboutModal = useCallback(() => {
    setAboutModalOpen(true);
  }, []);

  const closeAboutModal = useCallback(() => {
    setAboutModalOpen(false);
  }, []);

  const aiSplitButtonItems = useMemo(
    () => [
      {
        label: 'SWMS AI Wizard',
        icon: <OdinIcon icon="Sparkles" size={OdinIconSize.ExtraSmall} className="mr-2" />,
      },
      {
        label: 'Import SWMS',
        icon: <OdinIcon icon="Upload" size={OdinIconSize.ExtraSmall} className="mr-2" />,
      },
    ],
    []
  );

  const saveSplitButtonItems = useMemo(
    () => [
      {
        label: 'Create Backend Records',
        icon: <OdinIcon icon="SquarePlus" size={OdinIconSize.ExtraSmall} className="mr-2" />,
      },
      {
        label: 'Delete',
        icon: <OdinIcon icon="Trash" size={OdinIconSize.ExtraSmall} className="mr-2" />,
      },
    ],
    []
  );

  return (
    <div className="flex h-14 w-screen flex-row items-center gap-x-2 bg-mono-1">
      <img src={MyoshLogo} alt="Myosh Logo" className="w-[130px]" />
      <div className="max-w-80 min-w-80">
        <DropDown
          textField="text"
          valueField="value"
          data={[]}
          allowClear={false}
          className="h-12 rounded bg-gray-5"
          selectorStyles="text-base font-bold leading-9"
        />
      </div>
      <SplitButton
        label="Add SWMS"
        model={aiSplitButtonItems}
        variant="alternative"
        className="min-w-52"
        icon={<OdinIcon icon="Plus" size={OdinIconSize.ExtraSmall} className="mr-2" />}
      />
      <SplitButton
        label="Save"
        model={saveSplitButtonItems}
        className="min-w-52"
        icon={<OdinIcon icon="Save" size={OdinIconSize.ExtraSmall} className="mr-2" />}
      />
      <OdinIcon
        icon="Filter"
        size={OdinIconSize.Small}
        className="cursor-pointer rounded text-primary-1 hover:bg-primary-5"
      />
      <div onClick={openAboutModal} className="mr-2 ml-auto items-center justify-center">
        <OdinIcon icon="Menu" className="cursor-pointer rounded text-primary-1 hover:bg-primary-5" />
      </div>
      <AboutModal open={aboutModalOpen} onClose={closeAboutModal} />
    </div>
  );
};

export default memo(Header);
